import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkFixingRuleImplEncoder } from "../../encoder/BenchmarkFixingRuleImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkFixingRule } from "../BenchmarkFixingRule";

export class BenchmarkFixingRuleImpl extends ConcreteEncodable implements BenchmarkFixingRule {
  public static enType: string = "com.bcdfx.model.BenchmarkFixingRuleImpl";

  /*FID=1*/
  public ruleId: CubiqTS.Long | null = null;
  /*FID=2*/
  public benchmarkCd: string;
  /*FID=3*/
  public branchCd: string;
  /*FID=4*/
  public localTime: CubiqTS.Long | null = null;
  /*FID=5*/
  public timezoneCd: string;
  /*FID=6*/
  public currencyPairGroupId: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkFixingRuleImplEncoder.Instance;
    this.setEncodableType(BenchmarkFixingRuleImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkFixingRuleImpl[" +
      "ruleId=" +
      this.ruleId +
      "benchmarkCd=" +
      this.benchmarkCd +
      "branchCd=" +
      this.branchCd +
      "localTime=" +
      this.localTime +
      "timezoneCd=" +
      this.timezoneCd +
      "currencyPairGroupId=" +
      this.currencyPairGroupId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
